export enum Collections {
  calls = "calls",
  users = "users",
  messages = "messages",
  agent = "agent",
}
